import requestInstance from "./Request";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;

function buildBannerFormData(data) {
  const formData = new FormData();
  if (data.title) formData.append("title", data.title);
  if (data.link) formData.append("link", data.link);
  // If image is an object with a File, use the file, else skip
  if (data.bannerImage && data.bannerImage.file) {
    formData.append("bannerImage", data.bannerImage.file);
  }
  // Add dateRange fields if present
  if (data.dateRange) {
    if (data.dateRange.startDate) formData.append("startDate", data.dateRange.startDate);
    if (data.dateRange.endDate) formData.append("endDate", data.dateRange.endDate);
  }
  // Add city if present (assuming city is an object with id or a string)
  if (data.city) {
    if (typeof data.city === "object" && data.city.id) {
      formData.append("city", data.city.id);
    } else {
      formData.append("city", data.city);
    }
  }
  return formData;
}

const staticBannerService = {
  // GET: Fetch all banners
  async getBannerList(params = {}) {
    try {
      const response = await requestInstance.get(`${BASE_URL}/admin-api/v1/banners`, {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching banner list:", error);
      throw error;
    }
  },

  // POST: Create a new banner
  async createBanner(bannerData) {
    try {
      const formData = buildBannerFormData(bannerData);
      const response = await requestInstance.post(`${BASE_URL}/admin-api/v1/banners`, formData);
      return response.data;
    } catch (error) {
      console.error("Error creating banner:", error);
      throw error;
    }
  },

  // PATCH: Update a banner
  async updateBanner(bannerId, updatedData) {
    try {
      const formData = buildBannerFormData(updatedData);
      const response = await requestInstance.patch(`${BASE_URL}/admin-api/v1/banners/${bannerId}`, formData);
      return response.data;
    } catch (error) {
      console.error("Error updating banner:", error);
      throw error;
    }
  },

  // DELETE: Delete a banner
  async deleteBanner(bannerId) {
    try {
      const response = await requestInstance.delete(`${BASE_URL}/admin-api/v1/banners/${bannerId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting banner:", error);
      throw error;
    }
  },

  async addToHighLight(highLightData) {
    try {
      const formData = highLightData;
      const response = await requestInstance.post(`${BASE_URL}/admin-api/v1/highlights`, formData, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating banner:", error);
      throw error;
    }
  },
};

export default staticBannerService;